import React from "react";
import { bool, string } from "prop-types";
import { CORPORATE_ENVIRONMENT_TYPE, CORPORATE_GROUP_ENVIRONMENT_TYPE, RETAIL_ENVIRONMENT_TYPE, CORPORATE_PH_ENVIRONMENT_TYPE } from "../../constants";
import Image from "./Image";

function EnvironmentTag({ type, name, environmentIcon }) {
    return (
        <div className="environment-tag pr-0">
            <span className="visually-hidden"> {`${type}, ${name}`} </span>
            {environmentIcon && (type === CORPORATE_ENVIRONMENT_TYPE || type === CORPORATE_PH_ENVIRONMENT_TYPE || type === CORPORATE_GROUP_ENVIRONMENT_TYPE) && (
                <Image src="figma/icon/corporate.svg" className="svg-icon" />
            )}
            {environmentIcon && type === RETAIL_ENVIRONMENT_TYPE && <Image src="retail.svg" className="svg-icon" />}
            <span aria-hidden>{name}</span>
        </div>
    );
}

EnvironmentTag.propTypes = {
    environmentIcon: bool,
    name: string.isRequired,
    type: string.isRequired,
};

EnvironmentTag.defaultProps = {
    environmentIcon: false,
};

export default EnvironmentTag;
